<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import Earning from "./earning";
import TopItems from "@/components/topItems";
import PurchaseVolume from './purchaseVolume'
import AccessHistory from "@/components/accessHistory";
import OrdersStatus from "@/components/ordersStatus";
import Synchronization from "@/components/synchronization";
import SearchHistory from "@/components/search-history";
import InvoicesStatus from "@/components/invoicesStatus";
import QuantityVolume from "./quantityPerTraderAndBrand.vue";
import {Priviliges} from "../../../privileges";

/**
 * Reporting component
 */
export default {
  page: {
    title: "Les Rapports",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout,Earning,TopItems,PurchaseVolume,AccessHistory,OrdersStatus,Synchronization,SearchHistory,InvoicesStatus,QuantityVolume},

    mounted(){
      this.role=sessionStorage.getItem("userr");
      this.getCurrentMonthAndYear()
      var date = new Date();
      this.firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      const startoffset = this.firstDay.getTimezoneOffset()
      this.firstDay= new Date(this.firstDay.getTime() - (startoffset*60*1000))
      this.firstDay=this.firstDay.toISOString().split('T')[0]

      this.lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
      const endoffset = this.lastDay.getTimezoneOffset()
      this.lastDay= new Date(this.lastDay.getTime() - (endoffset*60*1000))
      this.lastDay=this.lastDay.toISOString().split('T')[0]


  },
  data() {
    return {
      currentYear:null,
      currentMonth:null,
      role:null,
      privileges:"",
      isAdmin:false,
      hasReportingAccess:false,
      hasCustomersHistoryAcess:false,
      hasSynchronisationAccess:false,
      firstDay:"",
      lastDay:"",
    };
  },


  methods: {
    getCurrentMonthAndYear(){
        var dt = new Date();
        this.currentMonth=dt.getMonth();
        this.currentYear  = dt.getFullYear();
        if(sessionStorage.getItem("privileges")!=null){
          this.privileges=sessionStorage.getItem("privileges")
          this.isAdmin=this.privileges.includes(Priviliges[0]["Admin_Role"] )
          this.hasReportingAccess=this.privileges.includes(Priviliges[0]["Sales_Statistics_Access"] )
          this.hasCustomersHistoryAcess=this.privileges.includes(Priviliges[0]["Customer_Histories_Access"] )
          this.hasSynchronisationAccess=this.privileges.includes(Priviliges[0]["Synchronization_Reports_Access"] )
        }
    },

  }
};
</script>

<template>
  <Layout>
  <div class="row p-4">
    <div class="col-12">
      <div v-if="role==1">
        <b-tabs class="pb-4 pt-4"  fill justified nav-class="nav-tabs-custom" content-class="p-0 text-muted" align="center" active-nav-item-class="font-weight-bold text-uppercase ">
            <b-tab v-if="isAdmin || hasReportingAccess"  lazy >
              <template v-slot:title>
                  <span class="d-inline-block d-md-none">
                  <i class="fas fa-chart-bar font-size-16 "/>
                  </span>
                  <i class="d-none d-md-inline-block fas fa-chart-bar  font-size-18 pr-2"/><br/><span class="d-none d-md-inline-block font-size-16">{{$t('reporting.supplier.tabSalesStats.title')}}</span>
              </template>
              <div class="row mt-4">
                <div class="col-md-6 pr-md-4">
                  <Earning :isMonthly="true" :currentMonth="new Date().getMonth()" :currentYear="new Date().getFullYear()"  />
                </div>

                <div class="col-md-6">
                  <Earning :isYearly="true" :currentMonth="new Date().getMonth()" :currentYear="new Date().getFullYear()" />
                </div>
              </div>
              <div class="row mt-4">
                <div class="col-md-6 pr-md-4  ">
                  <div class="card h-100  m-2 ">
                    <div class="card-body p-0" >
                      <QuantityVolume :firstDay=this.firstDay :lastDay=this.lastDay  />
                    </div>
                  </div>
                </div>
                <div class="col-md-6 pt-4 pt-md-0 ">
                  <div class="card h-100 m-2 ">
                    <div class="card-body p-0">
                      <PurchaseVolume :firstDay=this.firstDay :lastDay=this.lastDay  />
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt-4">
                <div class="col-md-6 pr-md-4">
                  <div class="card h-100 m-2 ">
                    <div class="card-body p-0" >
                      <OrdersStatus :firstDay=this.firstDay :lastDay=this.lastDay  />
                    </div>
                  </div>
                </div>
                <div class="col-md-6 pt-4 pt-md-0 ">
                  <div class="card h-100  m-2 ">
                    <div class="card-body p-0" >
                      <InvoicesStatus />
                    </div>
                  </div>
                </div>
              </div>  
              <div class="row mt-4">
                <div class="col-12  ">
                  <div class="card h-100  m-2 ">
                    <div class="card-body p-0" >
                    <TopItems :isReportingPage=true  :firstDay=this.firstDay :lastDay=this.lastDay  />
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>
            <b-tab v-if="isAdmin || hasCustomersHistoryAcess"  lazy >
              <template v-slot:title>
                  <span class="d-inline-block d-md-none">
                  <i class="fa fa-history font-size-16"></i>
                  </span>
                  <i class="d-none d-md-inline-block fa fa-history font-size-18 pr-2"/><br/><span class="d-none d-md-inline-block font-size-16">{{$t('reporting.supplier.tabHistory.title')}}</span>
              </template>
              <div class="row mt-4">
                <div class="col-12">
                  <div class="card  m-2 ">
                    <div class="card-body p-0" >
                      <SearchHistory  />
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt-4">
                <div class="col-12 ">
                  <div class="card  m-2">
                    <div class="card-body p-0">
                      <AccessHistory  />
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>
            <b-tab v-if="isAdmin || hasSynchronisationAccess" lazy >
              <template v-slot:title>
                  <span class="d-inline-block d-md-none">
                  <i class="fas fa-sync-alt  font-size-16"></i>
                  </span>
                  <i class="d-none d-md-inline-block fas fa-sync-alt  font-size-18 pr-2"/><br/><span class="d-none d-md-inline-block font-size-16">{{$t('reporting.supplier.tabSynchro.title')}}</span>
              </template>
              <div class="row pt-4">
                <div class="col-sm-12">
                  <div class="card  m-2 ">
                    <div class="card-body p-0">
                        <Synchronization/>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>
        </b-tabs>
      </div>

      <div v-if="role==0">
        <div class="row mt-4">
          <div class="col-md-6 pr-md-4">
            <Earning :isMonthly="true" :currentMonth="new Date().getMonth()" :currentYear="new Date().getFullYear()"  />
          </div>

          <div class="col-md-6">
            <Earning :isYearly="true" :currentMonth="new Date().getMonth()" :currentYear="new Date().getFullYear()" />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-6 pr-md-4  ">
            <div class="card h-100  m-2 ">
              <div class="card-body p-0" >
              <TopItems :isReportingPage=true  :firstDay=this.firstDay :lastDay=this.lastDay  />
              </div>
            </div>
          </div>
          <div class="col-md-6 pt-4 pt-md-0 ">
            <div class="card h-100 m-2 ">
              <div class="card-body p-0">
                <PurchaseVolume :firstDay=this.firstDay :lastDay=this.lastDay  />
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-md-6 pr-md-4">
            <div class="card h-100 m-2 ">
              <div class="card-body p-0" >
                <OrdersStatus :firstDay=this.firstDay :lastDay=this.lastDay />
              </div>
            </div>
          </div>
          <div class="col-md-6 pt-4 pt-md-0 ">
            <div class="card h-100  m-2 ">
              <div class="card-body p-0" >
                <InvoicesStatus />
              </div>
            </div>
          </div>
        </div>  
      </div>


    </div>
  </div>

  </Layout>
</template>
